import { z } from 'zod'
import { REQUIRED_MESSAGE } from '@Const/error-messages'
import { stringSizeMaxMessage } from '@Entities/schemas/work/error-messages'
import { IPIValidator, IsniValidator } from '@App/helpers/validate'
import { FormFields } from '@App/forms/v2/common/form-field'
import { FormFieldTypes } from '@App/enum/form-field-types'
import populateSchema from '@App/forms/v2/helpers/populate-schema'

const nameKey = 'name'
const ipiNumberKey = 'ipiNumber'
const hfaPublisherNumberKey = 'hfaPublisherNumber'
const isniKey = 'isni'
const ipIdKey = 'ipId'
const nameLabel = 'Name'
const ipiNumberLabel = 'Publisher IPI Number'
const hfaPublisherNumberLabel = 'Publisher Account Number'
const isniLabel = 'ISNI'

const rightsholderMaintenanceBaseSchema = z.object({
    [nameKey]: z
        .string({
            error: REQUIRED_MESSAGE,
        })
        .min(1, REQUIRED_MESSAGE)
        .max(200, stringSizeMaxMessage(nameLabel, 200)),
    [ipiNumberKey]: z
        .string()
        .max(11, stringSizeMaxMessage(ipiNumberLabel, 11))
        .refine((ipi) => IPIValidator(ipi, false), 'Invalid IPI Number')
        .optional()
        .nullish(),
    [hfaPublisherNumberKey]: z.string().max(6, stringSizeMaxMessage(hfaPublisherNumberLabel, 6)).optional().nullish(),
    [isniKey]: z
        .string()
        .refine((isni) => IsniValidator(isni, false), 'Invalid ISNI')
        .optional()
        .nullish(),
})

const rightsholderMaintenanceSchema = rightsholderMaintenanceBaseSchema.merge(
    z.object({
        [ipIdKey]: z.number(),
    })
)

type RightsholderMaintenanceBaseType = z.infer<typeof rightsholderMaintenanceBaseSchema>
type RightsholderMaintenanceType = z.infer<typeof rightsholderMaintenanceSchema>
type RightsholderMaintenanceInput = z.input<typeof rightsholderMaintenanceSchema>

const rightsholderMaintenanceFormFieldsNoSchema: FormFields<RightsholderMaintenanceBaseType> = {
    [nameKey]: {
        name: nameKey,
        label: nameLabel,
        type: FormFieldTypes.TEXT,
    },
    [ipiNumberKey]: {
        name: ipiNumberKey,
        label: ipiNumberLabel,
        type: FormFieldTypes.TEXT,
    },
    [hfaPublisherNumberKey]: {
        name: hfaPublisherNumberKey,
        label: hfaPublisherNumberLabel,
        type: FormFieldTypes.TEXT,
    },
    [isniKey]: {
        name: isniKey,
        label: isniLabel,
        type: FormFieldTypes.TEXT,
    },
}

const rightsholderMaintenanceFormFields: FormFields<RightsholderMaintenanceBaseType> = populateSchema(
    rightsholderMaintenanceFormFieldsNoSchema,
    rightsholderMaintenanceSchema
)

export {
    rightsholderMaintenanceFormFields,
    RightsholderMaintenanceType,
    RightsholderMaintenanceInput,
    rightsholderMaintenanceSchema,
}
